import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import ErrorPage from '../views/ErrorPage.vue';

const routes = [
  { path: '/', name: 'home', component: Home, meta: { requiresAuth: false } },
  { path: '/error/:code', name: 'error', component: ErrorPage, meta: { requiresAuth: false } },
  {
    path: '/pdf',
    name: 'pdf',
    component: () => import('../views/UploadPdf.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/delivery',
    name: 'delivery',
    component: () => import('../views/Delivery.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/OrderPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/order-confirmation',
    name: 'orderConfirmation',
    component: () => import('../views/OrderConfirmation.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/my-orders',
    name: 'myOrders',
    component: () => import('../views/MyOrder.vue'),
    meta: { requiresAuth: false },
  },
];

const router = createRouter({ history: createWebHistory(), routes });

export default router;
